'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _en_US = require('rc-pagination/lib/locale/en_US');

var _en_US2 = _interopRequireDefault(_en_US);

var _vi_VN = require('../date-picker/locale/vi_VN');

var _vi_VN2 = _interopRequireDefault(_vi_VN);

var _vi_VN3 = require('../time-picker/locale/vi_VN');

var _vi_VN4 = _interopRequireDefault(_vi_VN3);

var _vi_VN5 = require('../calendar/locale/vi_VN');

var _vi_VN6 = _interopRequireDefault(_vi_VN5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_moment2["default"].locale('vi');
exports["default"] = {
    locale: 'vi',
    Pagination: _en_US2["default"],
    DatePicker: _vi_VN2["default"],
    TimePicker: _vi_VN4["default"],
    Calendar: _vi_VN6["default"],
    Table: {
        filterTitle: 'Bộ ',
        filterConfirm: 'OK',
        filterReset: 'Tạo Lại',
        emptyText: 'Trống',
        selectAll: 'Chọn Tất Cả',
        selectInvert: 'Chọn Ngược Lại'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Huỷ',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Huỷ'
    },
    Transfer: {
        notFoundContent: 'Không Tìm Thấy',
        searchPlaceholder: 'Tìm ở đây',
        itemUnit: 'mục',
        itemsUnit: 'mục'
    },
    Select: {
        notFoundContent: 'Không Tìm Thấy'
    },
    Upload: {
        uploading: 'Đang tải lên...',
        removeFile: 'Gỡ bỏ tập tin',
        uploadError: 'Lỗi tải lên',
        previewFile: 'Xem thử tập tin'
    }
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/vi_VN.tsx
 ** module id = 801
 ** module chunks = 1
 **/